
export interface PromptFlowExecutionRequest {
    templateSlug: string;
    conversationThreadId: string;
    projectId: number;
    inputData: object;
    responseType: ResponseType;
    includeCrawlerDataset: boolean;
    includeSections: boolean;
    includeProjectInfo: boolean;
    seedKeywords?: string[];
}

export enum ResponseType {
    String = 'string',
    Object = 'object'
}